import styled from '@emotion/styled';
import { Link } from '@reach/router';
import { COLORS } from '../../constants';

export const StyledLongLink = styled(Link)`
  background: ${COLORS.middleGray};
  border-radius: 5px;
  color: ${COLORS.mainTextColor};
  display: flex;
  position: relative;
  align-items: center;
  padding: 15px;
  cursor: pointer;
  text-decoration: none;
  font-weight: 800;
  margin-bottom: 15px;
  color: white;
  font-size: 20px;
  box-sizing: border-box;

  svg {
    position: absolute !important;
    right: 10px;
  }
`;
